<template>
  <div>
    <span class="text-muted font-weight-bold font-size-sm d-block mb-5">
      แต้มแต่ละรายการใช้การตั้งค่าที่มีผล ณ วันที่ได้รับแต้ม การแก้ไขภายหลังไม่เปลี่ยนวันหมดอายุของแต้มที่ได้รับไปแล้ว
    </span>
    <div class="table-responsive">
      <b-table
        :items="historyRows"
        :fields="fields"
        :busy="isLoading"
        :borderless="true"
        head-variant="light"
        show-empty
        empty-text="ยังไม่มีประวัติการแก้ไข"
      >
        <template #table-busy>
          <div class="text-center text-muted my-3">
            <b-spinner small class="mr-2"></b-spinner>
            กำลังโหลดข้อมูล...
          </div>
        </template>
        <template #cell(effective_at)="data">
          <span class="font-weight-bold">
            {{ formatThaiDateTime(data.item.effective_at) }}
          </span>
          <span class="mx-1">–</span>
          <span v-if="data.item.effective_until" class="font-weight-bold">
            {{ formatThaiDateTime(data.item.effective_until) }}
          </span>
          <template v-else>
            <span class="font-weight-bold">ปัจจุบัน</span>
            <b-badge
              :variant="data.item.is_enabled ? 'success' : 'secondary'"
              class="ml-2"
            >
              {{ data.item.is_enabled ? "เปิดใช้งาน" : "ปิดใช้งาน" }}
            </b-badge>
          </template>
        </template>
        <template #cell(change)="data">
          <span v-if="data.item.previous" class="text-muted">
            {{ data.item.previous.expiration_months }} เดือน
          </span>
          <span v-else class="text-muted">ตั้งค่าครั้งแรก</span>
          <span class="mx-2">→</span>
          <span class="font-weight-bolder text-primary">
            {{ data.item.expiration_months }} เดือน
          </span>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { formatThaiDateTime } from "../point-expire.helper";
import { fetchPointExpireConfigHistory } from "../point-expire.api";

export default {
  name: "PointExpireConfigHistory",
  props: {
    companyId: {
      type: [Number, String],
      default: null
    },
    reloadKey: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isLoading: false,
      history: [],
      fields: [
        { key: "effective_at", label: "ช่วงที่มีผล", class: "align-middle" },
        { key: "change", label: "อายุของแต้ม", class: "align-middle" },
        {
          key: "updated_by",
          label: "ผู้แก้ไข",
          class: "align-middle",
          formatter: (value) => value || "-"
        }
      ]
    };
  },
  computed: {
    historyRows() {
      return this.history.map((item, index) => ({
        ...item,
        previous: this.history[index + 1] || null
      }));
    }
  },
  watch: {
    companyId() {
      this.loadHistory();
    },
    reloadKey() {
      this.loadHistory();
    }
  },
  mounted() {
    this.loadHistory();
  },
  methods: {
    formatThaiDateTime,
    loadHistory() {
      this.isLoading = true;
      fetchPointExpireConfigHistory(this.companyId)
        .then((history) => {
          this.history = history;
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "โหลดประวัติการแก้ไขไม่สำเร็จ",
            text: error.message,
            confirmButtonText: "ตกลง"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
